import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import format from 'date-fns/format';

import Table from 'components/Table';

import { transactionDetails as TEXT } from 'locales/en/transaction';
import { ACTIONS } from '../fakeData';
import { DATE_WITH_HOUR } from 'utils/dateFormat';

const Actions = ({ data, ...rest }) => {
  return (
    <>
      <h2 className="text-javelin-gray-dark lg:text-xl text-base font-bold mb-5">
        {TEXT.actions.title}
      </h2>
      <Table
        titles={[
          TEXT.actions.name,
          TEXT.actions.initiated_by,
          TEXT.actions.target,
          TEXT.actions.status,
          TEXT.actions.created_at,
        ]}
        hasData={!!data.length}
        gridClassName="grid-5-2fr"
        {...rest}
      >
        {data.map((action, idx) => {
          const dataIndexNumber = data.length - 1 === idx ? 'last' : idx;

          return (
            <Fragment key={action.id}>
              <span
                data-index-number={dataIndexNumber}
                className="text-javelin-gray-dark text-xs py-3 px-5"
              >
                {action.name}
              </span>
              <span
                data-index-number={dataIndexNumber}
                className="text-javelin-gray-dark text-xs py-3 px-5 truncate"
              >
                {action.user.email || '-'}
              </span>
              <span
                data-index-number={dataIndexNumber}
                className="text-javelin-gray-dark text-xs py-3 px-5"
              >
                {action.target_id}
              </span>
              <span
                data-index-number={dataIndexNumber}
                className="text-javelin-gray-dark text-xs py-3 px-5 capitalize"
              >
                {action.status}
              </span>
              <span
                data-index-number={dataIndexNumber}
                className="text-javelin-gray-dark text-xs py-3 px-5"
              >
                {format(new Date(action.created_at), DATE_WITH_HOUR)}
              </span>
            </Fragment>
          );
        })}
      </Table>
    </>
  );
};

Actions.propTypes = {
  data: PropTypes.array,
};
Actions.defaultProps = {
  data: ACTIONS,
};

export default Actions;
